<template>
  <div id="modal-container">
    <transition name="fade">
      <div class="overlay" v-on:click="hide">
        <div class="modal">
          <a href="#" v-on:click="hide" class="hide-link">
            <i class="fa fa-times"></i>
          </a>
          <div v-html="content" class="modal-content"></div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: ["content"],
  methods: {
    hide: function(e) {
      // Note - checking currentTarget for hidelink (since clicking on a descendant is fine),
      // target for overlay (since clicking on a descendant is NOT fine to close (it's the modal)),
      // and target for modal-trigger-hide (since it doesn't actually have an event handler and we're
      // depending on bubbling.)
      if (
        e.currentTarget.classList.contains("hide-link") ||
        e.target.classList.contains("modal-trigger-hide") ||
        e.target.classList.contains("overlay")
      ) {
        e.preventDefault();
        // Commit seppuku.
        this.$destroy();
        document.querySelector("#modal-container").innerHTML = "";
        const closeEvent = new CustomEvent("modalClose");
        document.querySelector("#modal-container").dispatchEvent(closeEvent);
      }
    }
  }
};
</script>
